import { useState } from "react";

export default function LogoutConfirmModal({ onConfirm, onCancel }) {
  const [hoverConfirm, setHoverConfirm] = useState(false);
  const [hoverCancel,  setHoverCancel]  = useState(false);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(0,0,0,0.7)", backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div style={{
        background: "var(--bg-elevated)", border: "1px solid var(--border-strong)", borderRadius: "20px",
        padding: "36px 32px", maxWidth: "380px", width: "90%",
        boxShadow: "0 24px 60px rgba(0,0,0,0.7)",
        animation: "fadeUp 0.2s ease",
      }}>
        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(12px) scale(0.97); }
            to   { opacity: 1; transform: translateY(0) scale(1); }
          }
        `}</style>

        {/* Icon */}
        <div style={{
          width: "56px", height: "56px", borderRadius: "50%",
          background: "#2d1a1a", border: "1px solid #5a2a2a",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "24px", margin: "0 auto 20px",
        }}>🚪</div>

        {/* Title */}
        <h2 style={{
          textAlign: "center", fontSize: "20px",
          fontFamily: "'Capsule Sans', sans-serif", fontWeight: "600",
          color: "var(--text-primary)", marginBottom: "10px",
        }}>Sign out of Ledger?</h2>

        {/* Subtitle */}
        <p style={{
          textAlign: "center", fontSize: "13px", color: "var(--text-muted)",
          fontFamily: "'Capsule Sans', sans-serif", lineHeight: "1.6",
          marginBottom: "28px",
        }}>
          You'll need to sign back in to access<br />your financial dashboard.
        </p>

        {/* Session info */}
        <div style={{
          background: "var(--bg-main)", border: "1px solid var(--border)", borderRadius: "10px",
          padding: "12px 16px", marginBottom: "24px",
          display: "flex", alignItems: "center", gap: "10px",
        }}>
          <div style={{
            width: "28px", height: "28px", borderRadius: "50%",
            background: "linear-gradient(135deg, #D4AF37, #9A7C1E)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "12px", fontWeight: "700", color: "var(--text-primary)", flexShrink: 0,
          }}>R</div>
          <div>
            <div style={{ fontSize: "12px", color: "#D4AF37", fontWeight: "500" }}>Revanth Rondla</div>
            <div style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "'JetBrains Mono', monospace" }}>revanth@ledger.app</div>
          </div>
          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            <div style={{ fontSize: "10px", color: "var(--text-muted)", fontFamily: "'JetBrains Mono', monospace" }}>SESSION</div>
            <div style={{ fontSize: "10px", color: "#6fcf6f", fontFamily: "'JetBrains Mono', monospace" }}>● Active</div>
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onMouseEnter={() => setHoverCancel(true)}
            onMouseLeave={() => setHoverCancel(false)}
            onClick={onCancel}
            style={{
              flex: 1, padding: "12px",
              background: hoverCancel ? "var(--bg-hover)" : "var(--bg-card)",
              border: "1px solid var(--border-strong)", borderRadius: "10px",
              fontSize: "13px", color: "var(--text-secondary)",
              fontFamily: "'Capsule Sans', sans-serif", cursor: "pointer",
              transition: "all 0.2s",
            }}
          >Stay signed in</button>

          <button
            onMouseEnter={() => setHoverConfirm(true)}
            onMouseLeave={() => setHoverConfirm(false)}
            onClick={onConfirm}
            style={{
              flex: 1, padding: "12px",
              background: hoverConfirm ? "#c05050" : "#b04040",
              border: "1px solid #c05050", borderRadius: "10px",
              fontSize: "13px", color: "#fff", fontWeight: "500",
              fontFamily: "'Capsule Sans', sans-serif", cursor: "pointer",
              transition: "all 0.2s",
            }}
          >Sign Out</button>
        </div>
      </div>
    </div>
  );
}
